import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

import { chunkLoadRecovery } from 'src/shared/util/chunk-load-recovery';

/** Reloads the page once when a lazy code file fails to load; every other error, and a chunk error the reload didn't fix, goes to Sentry. */
@Injectable()
export class ChunkLoadErrorHandler implements ErrorHandler {
  private readonly sentryErrorHandler = Sentry.createErrorHandler();

  handleError(error: unknown): void {
    if (chunkLoadRecovery.recover(error)) {
      return;
    }
    this.sentryErrorHandler.handleError(error);
  }
}
